import PlayerStore from "@/store/player";
import {Notif, NotifType} from "@/store/player/types";
import {InfoPanel} from "@/scenes.ui/info-panel";
import {Tr} from "@/i18n/i18n";
import {Scene} from "phaser";
import {SoloIntroPanel} from "@/scenes.ui/solo-intro-panel";
import {LightIntroPanel} from "@/scenes.ui/light-intro-panel";
import {Keys} from "@/constants/key";
import BoosterUtils from "@/utils/booster-utils";
import {BoosterType} from "@/store/shop/types";

export class NotifManager {

    private static REFRESH_INTERVAL: number = 3000;
    private static timerId: number | undefined = undefined;

    public static setupNotifCheckingTask(scene: Scene, canvas: HTMLCanvasElement) {
        if (!NotifManager.timerId) {
            NotifManager.timerId = setInterval(() => {
                NotifManager.job(scene, canvas);
            }, NotifManager.REFRESH_INTERVAL);
        }
    }

    public static checkNotifs(scene: Scene, canvas: HTMLCanvasElement) {
        let player = PlayerStore.getPlayer();
        if (!!player.notifs) {
            for (let n of player.notifs) {
                NotifManager.checkNotif(scene, canvas, n.notifType);
            }
        }
    }

    private static job(scene: Scene, canvas: HTMLCanvasElement) {
        PlayerStore.getNotifs().then((notifs: Notif[]) => {
            if (!!notifs) {
                for (let n of notifs) {
                    NotifManager.checkNotif(scene, canvas, n.notifType);
                }
            }
        });
    }

    private static checkNotif(scene: Scene, canvas: HTMLCanvasElement, n: NotifType) {
        switch (n) {
            case NotifType.FRIEND_PURCHASE_SUCCESSFUL:

                if (scene && scene.scene && scene.scene.isActive()) {
                    let ip: InfoPanel = new InfoPanel(scene, canvas, Tr('success.purch'), Tr('pss.1'),
                        Tr('pss.2'), () => {});
                    ip.openAnimated();
                }
                break;
            case NotifType.PROMO_YA_GEMS_100:
                if (scene && scene.scene && scene.scene.isActive()) {
                    let ip1: SoloIntroPanel = new LightIntroPanel(scene, canvas, Tr('gft'), Tr('gft.by.code'),
                        Keys.ATLAS_BANK, 'gems-0', Tr('ya.promo.1'), Tr('with.love'), () => {
                            ip1.close();
                        });
                    ip1.openAnimated();
                }
                break;
            case NotifType.PROMO_YA_EXP:
                if (scene && scene.scene && scene.scene.isActive()) {
                    let ip2: SoloIntroPanel = new LightIntroPanel(scene, canvas, Tr('gft'), Tr('gft.by.code'),
                        Keys.ATLAS_BOOST, BoosterUtils.getIcon(BoosterType.EXP_MIDDLE), Tr('ya.promo.2'), Tr('with.love'), () => {
                            ip2.close();
                        });
                    ip2.openAnimated();
                }
                break;
            case NotifType.PROMO_YA_SILVER:
                if (scene && scene.scene && scene.scene.isActive()) {
                    let ip3: SoloIntroPanel = new LightIntroPanel(scene, canvas, Tr('gft'), Tr('gft.by.code'),
                        Keys.ATLAS_BOOST, BoosterUtils.getIcon(BoosterType.COMPLEX_SMALL), Tr('ya.promo.3'), Tr('with.love'), () => {
                            ip3.close();
                        });
                    ip3.openAnimated();
                }
                break;
            case NotifType.PROMO_YA_GOLD:
                if (scene && scene.scene && scene.scene.isActive()) {
                    let ip3: SoloIntroPanel = new LightIntroPanel(scene, canvas, Tr('gft'), Tr('gft.by.code'),
                        Keys.ATLAS_BOOST, BoosterUtils.getIcon(BoosterType.COMPLEX_MIDDLE), Tr('ya.promo.4'), Tr('with.love'), () => {
                            ip3.close();
                        });
                    ip3.openAnimated();
                }
                break;
        }
        PlayerStore.deleteNotif(n);

        if (NotifManager.timerId) {
            clearInterval(NotifManager.timerId);
            NotifManager.timerId = undefined;
        }
    }

}